import { IdentificationCardIcon } from '@phosphor-icons/react';

import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const License = (props: IconProps) => {
  const { size = 'md', ...rest } = props;

  return <IdentificationCardIcon size={Sizes[size]} {...rest} />;
};

License.displayName = 'License';
